/**
 * @typedef {{ width: number; height: number; left: number; top: number }} CaptureRect
 */

/**
 * @param {{
 *   captureRect: CaptureRect;
 *   viewportWidth: number;
 *   viewportHeight: number;
 * }} props
 */
function RoomRenderCaptureOverlay({ captureRect, viewportWidth, viewportHeight }) {
  if (
    !captureRect?.width ||
    !captureRect?.height ||
    !viewportWidth ||
    !viewportHeight
  ) {
    return null;
  }

  const { width, height, left, top } = captureRect;
  const right = left + width;
  const bottom = top + height;

  return (
    <>
      <div
        className="floorplan-room-render-capture-mask floorplan-room-render-capture-mask-top"
        style={{ left: 0, top: 0, width: '100%', height: top }}
        aria-hidden="true"
      />
      <div
        className="floorplan-room-render-capture-mask floorplan-room-render-capture-mask-bottom"
        style={{ left: 0, top: bottom, width: '100%', height: Math.max(0, viewportHeight - bottom) }}
        aria-hidden="true"
      />
      <div
        className="floorplan-room-render-capture-mask floorplan-room-render-capture-mask-left"
        style={{ left: 0, top, width: left, height }}
        aria-hidden="true"
      />
      <div
        className="floorplan-room-render-capture-mask floorplan-room-render-capture-mask-right"
        style={{ left: right, top, width: Math.max(0, viewportWidth - right), height }}
        aria-hidden="true"
      />
      <div
        className="floorplan-room-render-active-capture-frame"
        style={{ left, top, width, height }}
        aria-hidden="true"
      />
    </>
  );
}

export default RoomRenderCaptureOverlay;
